<template>
  <div>
    <v-expand-transition>
      <div v-if="expanded" class="expanded">
        <div>
          <v-autocomplete
            v-model="selectedColleagues"
            multiple
            :items="colleagues"
            :item-text="getColleagueName"
            :item-value="getColleagueValue"
            :search-input.sync="search"
          />
        </div>
        <TextInput
          ref="textInput"
          :value="text"
          leave-room-for-code="44px"
          @save="save"
          @cancel="cancel"
        />
        <span class="warning-message">
          {{ $t('mission.visibilityWarning') }}
        </span>
      </div>
    </v-expand-transition>
    <v-snackbar
      top
      color="red"
      v-model="showMissingMission"
    >
      {{ $t('mission.errorMissingMission') }}
    </v-snackbar>
    <v-snackbar
      top
      color="red"
      v-model="showMissingCollegues"
    >
      {{ $t('mission.errorMissingAssignee') }}
    </v-snackbar>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { types as userTypes } from '../../../store/user';
import TextInput from './TextInput';

export default {
  name: 'MissionCreationForm',
  components: {
    TextInput,
  },
  data() {
    return {
      expanded: false,
      text: '',
      selectedColleagues: [],
      search: '',
      showMissingCollegues: false,
      showMissingMission: false,
    };
  },
  computed: {
    ...mapGetters({
      colleagues: userTypes.getters.colleagues,
    }),
  },
  methods: {
    getColleagueName(colleague) {
      return `${colleague.firstName} ${colleague.lastName}`;
    },
    getColleagueValue(colleague) {
      return colleague;
    },
    toggle() {
      this.expanded = !this.expanded;
    },
    save({ text }) {
      if (!this.selectedColleagues.length) {
        this.showMissingCollegues = true;
        return;
      }
      if (!text) {
        this.showMissingMission = true;
        return;
      }

      this.$emit('save', { selectedColleagues: this.selectedColleagues, text });
      this.selectedColleagues = [];
    },
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>
<style scoped>
  .warning-message {
    font-size: 10px;
    color: grey;
    margin-top: 4px;
    margin-right: 2px;
    float: right;
  }
</style>
